module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="locked">\n    <div class="icon"><i class="fa fa-warning"></i></div>\n    <h2>Redeeming is disabled for your account at this time.</h2>\n    <p>Please contact customer service for more information.</p>\n</div>';

}
return __p
}